import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { useAdminAuth } from "../AuthContext";

export default function AdminLogin() {
  const { login } = useAdminAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const expired = new URLSearchParams(loc.search).get("expired");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(expired ? "Your session expired. Please log in again." : "");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email.trim().toLowerCase(), password);
      nav("/admin/dashboard");
    } catch (err) {
      setError(err.message || "Login failed.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-950 px-4" style={{ fontFamily: "Satoshi, sans-serif" }}>
      <div className="w-full max-w-md">
        <div className="mb-8 text-center">
          <span className="font-heading text-4xl font-bold text-white" style={{ fontFamily: "Cabinet Grotesk, sans-serif" }}>ASAI</span>
          <p className="mt-2 text-sm text-slate-400">Admin Console</p>
        </div>
        <form onSubmit={onSubmit} data-testid="admin-login-form" className="flex flex-col gap-4 rounded-2xl border border-white/10 bg-slate-900 p-8">
          <div className="mb-1 flex items-center gap-2 text-white">
            <Lock className="h-5 w-5 text-orange" /> <h1 className="text-xl font-semibold">Sign in</h1>
          </div>
          {error && (
            <div data-testid="admin-login-error" className="rounded-lg border border-red-500/30 bg-red-500/10 px-4 py-3 text-sm text-red-300">{error}</div>
          )}
          <label className="flex flex-col gap-1.5 text-sm text-slate-300">
            Email
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="admin-email"
              className="rounded-lg border border-white/10 bg-slate-800 px-4 py-3 text-white outline-none focus:border-orange" placeholder="admin@..." />
          </label>
          <label className="flex flex-col gap-1.5 text-sm text-slate-300">
            Password
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="admin-password"
              className="rounded-lg border border-white/10 bg-slate-800 px-4 py-3 text-white outline-none focus:border-orange" placeholder="••••••••" />
          </label>
          <button type="submit" disabled={loading} data-testid="admin-login-submit"
            className="mt-2 inline-flex items-center justify-center gap-2 rounded-lg bg-orange px-5 py-3 font-medium text-white transition-opacity hover:opacity-90 disabled:opacity-60">
            {loading ? <><Loader2 className="h-4 w-4 animate-spin" /> Signing in…</> : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
